<template>
<!-- snb -->
<nav id="snb">
    <section class="snb_sec mypage_wrap">
        <h2>{{ $t('TITLE.GLOBAL.MYPAGE') }}</h2>
        <div class="list">
            <ul class="list_mymenu">
                <!-- myPage top 3 -->
                <li v-for="menu in myPageList">
                    <a href="javascript:" @click="handleMoveMenu(menu)">{{ menu.menuNm }}</a>
                </li>
            </ul>
        </div>
    </section>

    <section class="bn_wrap">
        <ul class="list_banner">
            <li class="bn_box">
                <a
                    href="javascript:"
                    class="ico_support"
                    :title="$t('TITLE.LEFT.MENU.SUPPORT')"
                    @click="btnSupport"
                >{{ $t('TITLE.LEFT.MENU.SUPPORT') }}</a>
            </li>
        </ul>
    </section>
</nav>
<!-- //snb -->
</template>

<script>
import Vue                      from 'vue';
import { mapGetters }           from 'vuex';
import _                        from 'lodash';
import $                        from 'jquery';
import axios                    from 'axios';
import qs                       from 'query-string';
import store                    from '@/vuex/store';
import SDLLocale                from '@/mixin/SDLLocale';
import { SDLUtil, MenuUtil }    from '@/utils';
import { EventBus }             from '@/utils/EventBus';

export default {
    name : 'DotComSnb',
    data() {
        return {
            myPageList: [],
        }
    },
    computed: {
        ...mapGetters({
            menus: 'getMenus',
            myPages: 'getMyPages',
            storeParams: 'getParams'
        }),
        getUserInfo() {
            return SDLUtil.getLoginedUserInfo();
        },
        getMyPageList() {
            return this.myPages['subMenu'] || [];
        }
    },
    methods: {
        // 컴포넌트 생성시 동작
        async initLoad() {
            this.myPageList = this.getMyPageList;
        },
        // 메뉴 이동 이벤트
        handleMoveMenu(menu) {
            Vue.$log.info('▶ DotcomSnb.vue handleMoveMenu menu => ', menu);
            store.commit(
                'PARAMS',
                Object.assign(
                    this.storeParams,
                    {
                        menuId : menu.menuId,
                        menuGrpCd : menu.menuGrpCd || '',
                        menuGrpDetailCd : menu.menuGrpDetailCd || '',
                        creationYn : menu.creationYn
                    }
                )
            );

            // URL 이 없는 경우
            if(SDLUtil.isNull(menu['connUrl'])) {
                Vue.$log.warn("▶ DotcomSnb.vue handleMoveMenu 'URL' is null");
                return false;
            }

            let connUrl = menu.connUrl.replace('.skp', '');
            Vue.$log.info('▶ DotcomSnb.vue handleMove select url : ', connUrl);
            this.$router.push(connUrl);
        },
    },
    // keep-alive activated
    activated() {
        Vue.$log.info('▶ DotComSnb.vue activated.');
        // SNB 이벤트 등록
        this.initLoad();
    },
    // keep-alive deactivated
    deactivated(){
        Vue.$log.info('▶ DotComSnb.vue deactivated.');
    }
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/main/DotComSnb.vue